export const REFERRER_ANALYTIC_EVENTS = {
  REFERRER_CREATED: "REFERRER_CREATED",
  REFERRER_UPDATED: "REFERRER_UPDATED",
  REFERRER_DELETED: "REFERRER_DELETED",
};

